import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CSSProperties } from '../../../models/styles.interfaces';
import { BaseProperties } from '../../../models/ui.interfaces';
import {
  IconLabel,
  VisibilityConfig
} from './models/label-with-icon.interfaces';

@Component({
  selector: 'idp-label-with-icon',
  templateUrl: './label-with-icon.component.html',
  styleUrls: ['./label-with-icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LabelWithIconComponent
  implements BaseProperties<VisibilityConfig, IconLabel, CSSProperties>
{
  @Input() labelProperties: Partial<IconLabel>;
  @Input() config: VisibilityConfig = { visible: false } as VisibilityConfig;
  @Input() styles: CSSProperties;

  constructor() {
    this.labelProperties = this.initDefaultValues();
    this.styles = this.initStyleDefaultValues();
  }

  get textClasses() {
    return `idp-label__text idp-label__text--${this.labelProperties.size}  idp-label__text--${this.labelProperties.role} idp-label__text--line-height-${this.styles.lineHeight}`;
  }

  get containerClasses() {
    return `idp-label-container idp-label-container--vertical-align-${this.styles.verticalAlign}`;
  }

  initDefaultValues(): IconLabel {
    return {
      size: 'normal',
      role: 'title',
      iconPath: '',
      title: ''
    };
  }

  initStyleDefaultValues(): CSSProperties {
    return {
      lineHeight: 'normal',
      verticalAlign: 'start'
    };
  }
}
